import { render, staticRenderFns } from "./PagesSidebar.vue?vue&type=template&id=1e4a7301&scoped=true&"
import script from "./PagesSidebar.vue?vue&type=script&lang=js&"
export * from "./PagesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PagesSidebar.vue?vue&type=style&index=0&id=1e4a7301&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a7301",
  null
  
)

export default component.exports